import { render, staticRenderFns } from "./ContentItemContainer.vue?vue&type=template&id=5ed422ba&scoped=true&"
import script from "./ContentItemContainer.vue?vue&type=script&lang=js&"
export * from "./ContentItemContainer.vue?vue&type=script&lang=js&"
import style0 from "./ContentItemContainer.vue?vue&type=style&index=0&id=5ed422ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed422ba",
  null
  
)

export default component.exports